import Marquee from "react-fast-marquee";
import { SERVICES } from "../data/services";
import { Diamond } from "@phosphor-icons/react";

export const ServiceMarquee = ({ dark = false }) => (
  <div
    className={`py-8 border-y ${dark ? "border-white/10 bg-primary" : "border-primary/10 bg-white"}`}
    data-testid="service-marquee"
  >
    <Marquee speed={30} gradient={false} pauseOnHover>
      {SERVICES.map((s) => (
        <span key={s.slug} className="mx-12 inline-flex items-center gap-12">
          <span className={`font-display text-2xl sm:text-3xl font-light tracking-tight ${dark ? "text-white/80" : "text-primary/70"}`}>
            {s.name}
          </span>
          <Diamond size={12} weight="fill" className="text-accent" />
        </span>
      ))}
    </Marquee>
  </div>
);
